import { createContext, useContext } from 'react';
export const ButtonsContext = createContext(null);
export function useButtons() {
    const context = useContext(ButtonsContext);
    if (!context) {
        return { isMenuItem: false, handleClose: () => { } };
    }
    return { isMenuItem: true, handleClose: context };
}
